import "./index.css";
import { router } from "@/app/router";
import { TooltipProvider } from "@/components/ui/tooltip";
import { queryClient } from "@/lib/store";
import { useIsPhone } from "@/lib/media";
import { applyTheme, themeStore, useTheme } from "@/lib/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";

applyTheme(themeStore.get());

function AppToaster() {
  const theme = useTheme();
  const phone = useIsPhone();
  return <Toaster position={phone ? "top-center" : "bottom-right"} richColors closeButton={!phone} theme={theme} />;
}
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => applyTheme(themeStore.get()));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={400}>
        <RouterProvider router={router} />
        <AppToaster />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
